'use client';

import { useEffect, Fragment } from 'react';
import { initSegment, newPageViewId } from '@nerdwallet/seo-segment';
import { ExecuteClientScripts } from '@nerdwallet/compass/client-scripts';

type InitCompassProps = {
  analyticsKey: string;
  deployable_name: string;
  deployable_version: string;
};

export const InitCompass = ({
  analyticsKey,
  deployable_name,
  deployable_version,
}: InitCompassProps) => {
  useEffect(() => {
    ExecuteClientScripts();

    initSegment({
      analyticsKey,
      pageview_id: newPageViewId(),
      deployable_name,
      deployable_version,
    });
  }, [analyticsKey, deployable_name, deployable_version]);
  return <Fragment />;
};
